/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import notifications from 'notifications';
import * as SampleSchemaActions from 'samples/SampleSchemaActions';
import {ContainerSchema} from 'samples/storables/StorableSchemaConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {LABEL_STYLES} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';
import Modal from 'ui-library/modals/Modal';

interface Props {
  allContainerSchemas: Array<ContainerSchema>;
  registryId: string;
}

type State = any;

class CreateContainerSchemaModal extends React.Component<Props, State> {
  static open({allContainerSchemas, registryId}: any): void {
    LegacyModalContainer.open(
      'ADD_CONTAINER_SCHEMA_MODAL',
      <CreateContainerSchemaModal allContainerSchemas={allContainerSchemas} registryId={registryId} />
    );
  }

  override state: State = {
    name: '',
    prefix: '',
  };

  _handleSubmit = (): void => {
    if (this.props.allContainerSchemas.some(({name}) => name === this.state.name)) {
      notifications.warn('Name must not match an existing container schema!');
      return;
    }
    if (this.props.allContainerSchemas.some(({prefix}) => prefix === this.state.prefix)) {
      notifications.warn('Prefix must not match an existing container schema!');
      return;
    }
    const newContainerSchema = {
      name: this.state.name,
      prefix: this.state.prefix,
      allFields: [],
    };
    SampleSchemaActions.createContainerSchema(this.props.registryId, newContainerSchema);
    LegacyModalContainer.close('ADD_CONTAINER_SCHEMA_MODAL');
  };

  _disableSubmit = (): boolean => this.state.name.length === 0 || this.state.prefix.length === 0;

  _handleClose = (): void => {
    LegacyModalContainer.close('ADD_CONTAINER_SCHEMA_MODAL');
  };

  override render(): JSX.Element {
    return (
      <Modal
        title="Create container schema"
        buttons={[
          {text: 'Create', submit: true, style: ButtonStyle.PRIMARY, disabled: this._disableSubmit()},
        ]}
        onRequestSubmit={this._handleSubmit}
        onRequestClose={this._handleClose}
        analyticsModule={ANALYTICS_MODULE.SAMPLES}
        analyticsModalType="create_container_schema"
      >
        <div>
          <div>
            To create a new container schema, please enter a prefix and name. Once submitted, you will be able
            to add new fields.
          </div>
          <Row className="u-spacing-top">
            <Col xs={6}>
              <TextField
                autoFocus={true}
                className="u-mini-spacing-left"
                label="Prefix"
                labelStyle={LABEL_STYLES.LABEL}
                onChange={(e) => {
                  this.setState({prefix: e.target.value});
                }}
                value={this.state.prefix}
                dataTestAttrs={{component: 'CreateContainerSchemaModal', element: 'prefixField'}}
              />
            </Col>
            <Col xs={6}>
              <TextField
                className="u-mini-spacing-left"
                label="Name"
                labelStyle={LABEL_STYLES.LABEL}
                onChange={(e) => {
                  this.setState({name: e.target.value});
                }}
                value={this.state.name}
                dataTestAttrs={{component: 'CreateContainerSchemaModal', element: 'nameField'}}
              />
            </Col>
          </Row>
        </div>
      </Modal>
    );
  }
}

export default CreateContainerSchemaModal;
